export enum AppErrorEnumeration {
  CHECKOUT_NO_INFO = 'CHECKOUT_NO_INFO',
  CUSTOMER_AUTHORIZATION_FAILED = 'CUSTOMER_AUTHORIZATION_FAILED',
  DECLINED_ONBOARDING = 'DECLINED_ONBOARDING',
  NO_ONE_TOKEN = 'NO_ONE_TOKEN',
  PDF_VIEWER_ERROR = 'PDF_VIEWER_ERROR',
  STATE_FAILED = 'STATE_FAILED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  FETCH_STEP_DETAILS_FAILED = 'FETCH_STEP_DETAILS_FAILED',

  // Contractual
  SAVE_PAYMENT_METHOD_FAILED = 'SAVE_PAYMENT_METHOD_FAILED',
  SAVE_CONTRACTUAL_FAILED = 'SAVE_CONTRACTUAL_FAILED',
  GENERATE_OTP_FAILED = 'GENERATE_OTP_FAILED',
  CONTRACTUAL_SCREEN_DETAILS_FAILED = 'CONTRACTUAL_SCREEN_DETAILS_FAILED',
  VERIFY_OTP_FAILED = 'VERIFY_OTP_FAILED',
  GET_OTP_INFO_FAILED = 'GET_OTP_INFO_FAILED',
  SAVE_PRECONTRACT_FAILED_WITH_CONSENTS = 'SAVE_PRECONTRACT_FAILED_WITH_CONSENTS',
  PRECONTRACT_FAILED_NO_CONSENTS = 'PRECONTRACT_FAILED_NO_CONSENTS',
  PRECONTRACT_SCREEN_DETAILS_FAILED = 'PRECONTRACT_SCREEN_DETAILS_FAILED',
  GET_SIGNATURE_DETAILS_FAILED = 'GET_SIGNATURE_DETAILS_FAILED',
  // KYC
  BIZUM_WS_STATUS_REJECTED = 'BIZUM_WS_STATUS_REJECTED',
  BIZUM_WS_ERROR = 'BIZUM_WS_ERROR',
  KYC_INITIALIZE_FAILED = 'KYC_INITIALIZE_FAILED',
  KYC_METHOD_WS_STATUS_REJECTED = 'METHOD_WS_STATUS_REJECTED',
  COMPLETE_ACCOUNT_CHECK_FAILED = 'COMPLETE_ACCOUNT_CHECK_FAILED',
  ACCOUNT_CHECK_INVALID_TINK_ERROR = 'ACCOUNT_CHECK_INVALID_TINK_ERROR',
  WS_BIZUM_TIMEOUT = 'WS_BIZUM_TIMEOUT',
  WS_VIDEOCALL_TIMEOUT = 'WS_VIDEOCALL_TIMEOUT',
  VIDEOCALL_IFRAME_LOAD_ERROR = 'VIDEOCALL_IFRAME_LOAD_ERROR',
  ACCOUNT_CHECK_IFRAME_LOAD_ERROR = 'OPENBANKING_IFRAME_LOAD_ERROR',
  VIDEOCALL_IFRAME_FETCH_URL_ERROR = 'VIDEOCALL_IFRAME_FETCH_URL_ERROR',
  ACCOUNT_CHECK_IFRAME_FETCH_URL_ERROR = 'ACCOUNT_CHECK_IFRAME_FETCH_URL_ERROR',
  GET_IDENTIFICATION_DETAILS_FAILED = 'GET_IDENTIFICATION_DETAILS_FAILED',
  BACK_STATE_KYC_FAILED = 'BACK_STATE_KYC_FAILED',
  VERIDAS_VIDEOCALL_ERROR_EVENT = 'VERIDAS_VIDEOCALL_ERROR_EVENT',
  // Payment
  STRIPE_SUBMIT_ELEMENTS_FAILED = 'STRIPE_SUBMIT_ELEMENTS_FAILED',
  STRIPE_CREATE_PAYMENT_METHOD_FAILED = 'STRIPE_CREATE_PAYMENT_METHOD_FAILED',
  STRIPE_PAYMENT_METHOD_WITHOUT_CARD = 'STRIPE_PAYMENT_METHOD_WITHOUT_CARD',
  STRIPE_CHECK_PAYMENT_CARD_FAILED = 'STRIPE_CHECK_PAYMENT_CARD_FAILED',
  STRIPE_CONFIRM_PAYMENT_FAILED = 'STRIPE_CONFIRM_PAYMENT_FAILED',
  PAYMENT_INITIALIZE_FAILED = 'PAYMENT_INITIALIZE_FAILED',
  GET_PAYMENT_DETAILS_FAILED = 'GET_PAYMENT_DETAILS_FAILED',
  WS_PAYMENT_TIMEOUT = 'WS_PAYMENT_TIMEOUT',
  PAYMENT_WS_ERROR = 'PAYMENT_WS_ERROR',
  // Proof of Income
  PROOF_OF_INCOME_WS_REJECTED = 'PROOF_OF_INCOME_WS_REJECTED',
  COMPLETE_OPENBANKING_FAILED = 'COMPLETE_OPENBANKING_FAILED',
  OPENBANKING_INVALID_TINK_ERROR = 'OPENBANKING_INVALID_TINK_ERROR',
  WS_TGSS_TIMEOUT = 'WS_TGSS_TIMEOUT',
  INITIALIZE_PROOF_OF_INCOME_FAILED = 'INITIALIZE_PROOF_OF_INCOME_FAILED',
  TGSS_IFRAME_LOAD_ERROR = 'TGSS_IFRAME_LOAD_ERROR',
  OPENBANKING_IFRAME_LOAD_ERROR = 'OPENBANKING_IFRAME_LOAD_ERROR',
  TGSS_IFRAME_FETCH_URL_ERROR = 'TGSS_IFRAME_FETCH_URL_ERROR',
  OPENBANKING_IFRAME_FETCH_URL_ERROR = 'OPENBANKING_IFRAME_FETCH_URL_ERROR',
  GET_INCOME_DETAILS_FAILED = 'GET_INCOME_DETAILS_FAILED',
  BACK_STATE_PROOF_OF_INCOME_FAILED = 'BACK_STATE_PROOF_OF_INCOME_FAILED',
  // Upload Id
  SAVE_DIFFERENT_DATA_FAILED = 'SAVE_DIFFERENT_DATA_FAILED',
  FETCH_OCR_DATA_FAILED = 'FETCH_OCR_DATA_FAILED',
  NO_VALIDATION_ID_ERROR = 'NO_VALIDATION_ID_ERROR',
  XPRESS_ID_URL_GENERATION_FAILED = 'XPRESS_ID_URL_GENERATION_FAILED',
  UPLOAD_ID_VERIFICATION_WS_REJECTED = 'VERIFICATION_WS_REJECTED',
  VERIDAS_ERROR_EVENT = 'VERIDAS_ERROR_EVENT',
  WS_VERIDAS_TIMEOUT = 'WS_VERIDAS_TIMEOUT',
  UPLOAD_ID_IFRAME_LOAD_ERROR = 'UPLOAD_ID_IFRAME_LOAD_ERROR',
  UPLOAD_ID_IFRAME_FETCH_URL_ERROR = 'UPLOAD_ID_IFRAME_FETCH_URL_ERROR',
  GET_ID_VALIDATION_DETAILS_FAILED = 'GET_ID_VALIDATION_DETAILS_FAILED',
}
